<template>
    <div>
        <div class="d-flex align-items-center justify-content-end">
            <alerts
                :status="alert"
                v-model="alert"
                class="categories-alerts"
            ></alerts>
        </div>
        <div>Click-and-drag to re-arrange categories</div>
        <div class="card panel panel-default actions p-4">
            <categories-tree-item
                :categories="categoriesFormatted"
                :group="{ name: 'categories' }"
                ref="draggable"
                :open-parent="true"
                :parent-id="1"
                @category-changed="handleCategoryChange"
            ></categories-tree-item>
        </div>
    </div>
</template>
<script type="text/javascript">
import CategoriesTreeItem from "./category-tree-item.vue";
import ProductAlerts from "../products/product-details-alerts.vue";

export default {
    name: "categories-tree",
    props: ["categories"],
    components: {
        "categories-tree-item": CategoriesTreeItem,
        alerts: ProductAlerts,
    },
    data() {
        return {
            categoriesFormatted: [],
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
        };
    },
    methods: {
        handleCategoryChange: function (alert) {
            this.alert.message = alert.message;
            this.alert.status = alert.status;

            setTimeout(function () {
                this.alert.message = "";
                this.alert.status = "";
            }, alert.timeOut);
        },
    },
    mounted() {
        // recursively iterates over categories array and adds
        // 'openChildren' property if children present
        const addToggleProperty = (data) =>
            data.map(({ children, ...rest }) => {
                if (children) {
                    return {
                        children: addToggleProperty(children),
                        openChildren: false,
                        ...rest,
                    };
                }

                return {
                    ...rest,
                };
            });

        this.categoriesFormatted = addToggleProperty(this.categories);
    },
};
</script>
